<div *ngIf="visible" class="w-100 d-flex flex-row justify-content-between align-items-center bg-kh-red-light px-kh-4 py-kh-3" khA11yAlert [khA11yAlertTrapFocus]="true">
  <div class="align-self-start mr-kh-2 mt-kh-1">
    <kh-img path="danger.svg" class="icon" khA11yHidden></kh-img>
  </div>
  <div class="content kh-medium-text text-left">
    <ng-content></ng-content>
  </div>
  <div class="pointer" (click)="toggleVisibility()" khA11yClickable [khA11yLabel]="'A11Y_ALERT.DISMISS' | translate">
    <fa-icon [icon]="['fas','times']"></fa-icon>
  </div>
</div>